import styled from 'styled-components';
import { sectionShell, sectionHeader, sectionTitle, sectionDescription } from '../../styles/sectionStyles';

export const Container = styled.section`
  ${sectionShell}
`;

export const Wrapper = styled.div`
  width: min(1180px, 100%);
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  align-items: end;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    align-items: start;
  }
`;

export const Header = styled.div`
  ${sectionHeader}
`;

export const SectionLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.18em;
  text-transform: uppercase;

  &::after {
    content: '';
    width: 64px;
    height: 1px;
    background: var(--surface);
  }
`;

export const Title = styled.h2`
  ${sectionTitle}
`;

export const Highlight = styled.span`
  color: var(--accent);
`;

export const Desc = styled.p`
  ${sectionDescription}
`;

export const FilterBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 13px 16px;
  border-radius: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: 0 18px 48px rgba(72, 50, 28, 0.08);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);

  @media (max-width: 900px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const FilterButton = styled.button`
  min-width: 78px;
  height: 42px;
  padding: 0 20px;
  border: 1px solid ${({ $active }) => $active ? 'var(--accent)' : 'var(--border)'};
  border-radius: 14px;
  color: ${({ $active }) => $active ? 'var(--button-text)' : 'var(--text)'};
  background: ${({ $active }) => $active ? 'var(--accent)' : 'var(--surface)'};
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  box-shadow: ${({ $active }) => $active ? '0 12px 24px rgba(249, 115, 22, 0.2)' : '0 8px 18px rgba(72, 50, 28, 0.05)'};
  transition: transform 160ms ease, box-shadow 160ms ease, color 160ms ease, background 160ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(249, 115, 22, 0.13);
  }

  @media (max-width: 520px) {
    flex: 1 1 calc(50% - 8px);
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const ExploreMore = styled.button`
  align-self: center;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 0 34px;
  border-radius: 999px;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: 0 16px 34px rgba(72, 50, 28, 0.07);
  font-size: 15px;
  font-weight: 650;
  cursor: pointer;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-2px);
    border-color: var(--accent);
    box-shadow: 0 18px 40px rgba(249, 115, 22, 0.12);
  }
`;

export const EmptyState = styled.div`
  padding: 42px;
  border-radius: 20px;
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--muted);
  text-align: center;
`;
